export function isValidSwissAvsNumber(avsNumber: string): boolean {
  const digits = avsNumber.replace(/\D/g, '');
  if (!/^756\d{10}$/.test(digits)) {
    return false;
  }

  const sum = digits
    .substring(0, 12)
    .split('')
    .reduce((acc, digit, index) => acc + Number(digit) * (index % 2 === 0 ? 1 : 3), 0);
  const checkDigit = (10 - (sum % 10)) % 10;

  return checkDigit === Number(digits[12]);
}
